<div class="mb-3">
    <div [ngClass]="getCardClass()" [id]="brand.prefix + '--group'">
        <div class="row">
            <div class="{{ brand.isOpen ? 'col' : 'col-12' }} col-xl brand-container">
                <!-- Logo -->
                <img [src]="brand.logoPath" [alt]="brand.name" class="img-fluid marca--brand" width="120" [style]="brand.logoStyle">
                <img [src]="brand.logoPath" [alt]="brand.name" class="img-fluid marca--brand--c" width="120" [style]="brand.logoStyle">
                <!-- Banner normalizado -->
                <h4 class="fw-bold banner" *ngIf="!brand.isOpen" [innerHTML]="brand.description"></h4>
                <div class="vl--brand"></div>
            </div>         

            <div class="{{ brand.isOpen ? 'col-auto' : 'col-12' }} col-xl-auto">
                <button *ngIf="!brand.isOpen" (click)="toggleOpen()" class="btn btn-white-outline--sm" type="button">
                    <b>Acceder</b>
                </button>

                <button *ngIf="brand.isOpen" (click)="toggleOpen()" class="btn px-0" type="button">
                    <img src="./assets/img/x-white.svg" style="margin-top: -30px;" alt="">
                </button>
            </div>
        </div>
    </div>

    <ng-container>
    <div [id]="brand.prefix" #contentRef
        [style.height]="brand.isOpen ? contentHeight + 'px' : '0px'"
        [style.overflow]="'hidden'"
        [style.transition]="'height 0.3s ease-in-out'">
            <ng-container *ngFor="let data of brand.data">
                <div class="card-body--brand" *ngIf="data.bodyPrincipalLinks.length > 0 || data.bodySecondaryLinks.length > 0">
                    <div class="row">
                        <div class="col-xl-12">
                            <div>
                                <h6 class="ms-2 marca--sub" *ngIf="data.bodyTitle != null">{{ data.bodyTitle }}</h6>

                                <div class="ms-2 mb-3" *ngIf="data.bodyPrincipalLinks.length > 0">
                                    <ng-container *ngFor="let link of data.bodyPrincipalLinks">
                                        <a *ngIf="!link.isExternal && link.onClick == null" [routerLink]="link.route" class="btn btn-black--outline btn-sm me-1 mb-1">
                                            <img [src]="link.imagePath" width="12" [alt]="link.label" class="me-2" *ngIf="link.imagePath">
                                            <span>{{ link.label }}</span>
                                        </a>

                                        <a *ngIf="link.isExternal && link.onClick == null" [href]="link.route" [attr.target]="link.isBlank ? '_blank' : null" class="btn btn-black--outline btn-sm me-1 mb-1">
                                            <img [src]="link.imagePath" width="12" [alt]="link.label" class="me-2" *ngIf="link.imagePath">
                                            <span>{{ link.label }}</span>
                                        </a>

                                        <a *ngIf="link.onClick != null" href="javascript:void(0)" (click)="link.onClick()" class="btn btn-black--outline btn-sm me-1 mb-1">
                                            <img [src]="link.imagePath" width="12" [alt]="link.label" class="me-2" *ngIf="link.imagePath">
                                            <span>{{ link.label }}</span>
                                        </a>
                                    </ng-container>
                                </div>

                                <div class="ms-2" *ngIf="data.bodySecondaryLinks.length > 0">
                                    <ng-container *ngFor="let link of data.bodySecondaryLinks">
                                        <a *ngIf="!link.isExternal && link.onClick == null" [routerLink]="link.route" class="btn btn-gray--round btn-sm me-1">
                                            <img [src]="link.imagePath" width="12" [alt]="link.label" class="me-2" *ngIf="link.imagePath">
                                            <span>{{ link.label }}</span>
                                        </a>

                                        <a *ngIf="link.isExternal && link.onClick == null" [href]="link.route" [attr.target]="link.isBlank ? '_blank' : null" class="btn btn-gray--round btn-sm me-1">
                                            <img [src]="link.imagePath" width="12" [alt]="link.label" class="me-2" *ngIf="link.imagePath">
                                            <span>{{ link.label }}</span>
                                        </a>

                                        <a *ngIf="link.onClick != null" href="javascript:void(0)" (click)="link.onClick()" class="btn btn-gray--round btn-sm me-1">
                                            <img [src]="link.imagePath" width="12" [alt]="link.label" class="me-2" *ngIf="link.imagePath">
                                            <span>{{ link.label }}</span>
                                        </a>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-footer--rm" *ngIf="data.footerLinks.length > 0">
                    <div class="row">
                        <div class="col-xl-12">
                            <div class="ms-2">
                                <ng-container *ngFor="let link of data.footerLinks">
                                    <a *ngIf="!link.isExternal && link.onClick == null" [routerLink]="link.route" class="black pe-3">
                                        <img [src]="link.imagePath" width="12" [alt]="link.label" class="me-2" *ngIf="link.imagePath">
                                        <span>{{ link.label }}</span>
                                    </a>

                                    <a *ngIf="link.isExternal && link.onClick == null" [href]="link.route" [attr.target]="link.isBlank ? '_blank' : null" class="black pe-3">
                                        <img [src]="link.imagePath" width="12" [alt]="link.label" class="me-2" *ngIf="link.imagePath">
                                        <span>{{ link.label }}</span>
                                    </a>

                                    <a *ngIf="link.onClick != null" href="javascript:void(0)" (click)="link.onClick()" class="black pe-3">
                                        <img [src]="link.imagePath" width="12" [alt]="link.label" class="me-2" *ngIf="link.imagePath">
                                        <span>{{ link.label }}</span>
                                    </a>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <div class="card-body--sm" *ngIf="brand.customMsg">
                <div class="row">
                    <div class="row mx-0">
                        <div class="col-auto">
                            <i-feather name="info" style="width: 48px;"></i-feather>
                        </div>
                        <div class="col ps-0" [innerHTML]="brand.customMsg"></div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
